import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import { EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { TRANSACTION_TYPES, TRANSACTION_TYPES_LABEL } from '../../constant';
import { VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS, ACTION_LABELS } from './constants';

export const makeActionList = (params?: any) => {
	const { keyConfig, [VIEW_FIELD_KEYS.TRANSACTION_TYPE]: transactionType, transactionAllDetails } = params;
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	switch (_get(keyConfig, 'name', EMPTY_STRING)) {
		case VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_ID:
			return [
				{
					id: ACTION_IDS.GET_RAZORPAY_PAYOUT_ID,
					label: ACTION_LABELS[ACTION_IDS.GET_RAZORPAY_PAYOUT_ID],
					isEnabled: () =>
						transactionType === TRANSACTION_TYPES_LABEL[TRANSACTION_TYPES.WITHDRAWAL] &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: USER_PROFILE_RESOURCES.transactionHistory,
							configActionName: ACTION.getRazorpayPayoutDetails
						})
				}
			];
		case VIEW_FIELD_KEYS.COUPONS_USED:
			return [
				{
					id: ACTION_IDS.GET_COUPON_TNC,
					label: ACTION_LABELS[ACTION_IDS.GET_COUPON_TNC],
					isEnabled: ({ keyData }: { keyData: string }) =>
						!_isEmpty(keyData) &&
						hasPermissionV2({
							configPageName: 'reward',
							configResourceName: USER_PROFILE_RESOURCES.coupons,
							configActionName: ACTION.getCouponTnC
						})
				}
			];
		case VIEW_FIELD_KEYS.COUPON_ID:
			return [
				{
					id: ACTION_IDS.GET_COUPON_TNC,
					label: ACTION_LABELS[ACTION_IDS.GET_COUPON_TNC],
					isEnabled: ({ keyData }: { keyData: number }) =>
						!_isNil(keyData) &&
						_isNil(transactionAllDetails?.extras?.couponCode) &&
						hasPermissionV2({
							configPageName: 'reward',
							configResourceName: USER_PROFILE_RESOURCES.coupons,
							configActionName: ACTION.getCouponTnC
						})
				}
			];
		default:
			return EMPTY_ARRAY;
	}
};

export default {
	makeActionList
};
